export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const MIN_PASSWORD_LENGTH = 6;

export const isValidEmail = (email) => EMAIL_REGEX.test(String(email || "").trim());
export const isValidPassword = (password) => String(password || "").length >= MIN_PASSWORD_LENGTH;
